<template>
  <div
    class="wr-notary-certificate-main"
    style="height: 100%; width: 100%;">

    <div style="text-align: center; color: #3b4047;">
      <div style="width: 1488px; display: block; margin: auto; text-align: left;" >

        <div
          class="not-printable"
          style="height: 168px;">
          <div class="notary-crt-caption">
            {{ $t('wr-notary-certificate.caption') }}
          </div>
          <div class="notary-crt-print-button">
            <button
              class="b-notary"
              onClick="window.print();"
              type="submit"><b><span>{{ $t('wr-notary-certificate.button.print') }}</span></b>
            </button>
          </div>
        </div>

        <div class="notary-crt-wrapper">
          <div style="position: relative;">

            <div class="notary-crt-crt-caption">
              {{ $t('wr-notary-certificate.certificate.caption') }}
            </div>
            <div class="notary-crt-sub-caption">
              {{ $t('wr-notary-certificate.certificate.sub-caption') }}
            </div>
            <div class="notary-crt-body-text">
              {{ $t('wr-notary-certificate.certificate.body-text') }}
            </div>

            <div class="notary-crt-data-view">
              <div class="notary-crt-name-wrapper">
                <div class="notary-crt-name-label">
                  {{ $t('wr-notary-certificate.certificate.name') }}
                </div>
                <div class="notary-crt-name">
                  {{ getDisplayFileName }}
                </div>
              </div>
              <div class="notary-crt-date-wrapper">
                <div class="notary-crt-date-label">
                  {{ $t('wr-notary-certificate.certificate.date-time') }}
                </div>
                <div class="notary-crt-date">
                  {{ getCrtDate | date }}
                </div>
              </div>
              <div class="notary-crt-signee-wrapper">
                <div class="notary-crt-signee-label">
                  {{ $t('wr-notary-certificate.certificate.signee') }}
                </div>
                <div class="notary-crt-signee">
                  {{ getCrtSignee }}
                </div>
              </div>
            </div>

          </div>
        </div>

        <div class="notary-crt-verify-wrapper">
          <div class="notary-crt-verify-caption">
            {{ $t('wr-notary-certificate.verify.caption') }}
          </div>
          <div class="notary-crt-verify-note">
            {{ $t('wr-notary-certificate.verify.note') }}
          </div>
        </div>


        <div class="notary-crt-how-to-block">


          <div class="notary-head-point">
            <div class="notary-circle-point"><span>1</span></div>
            <div class="notary-point-caption">
              {{ $t('wr-notary-certificate.verify.point1.caption') }}
            </div>
          </div>
          <br>
          {{ $t('wr-notary-certificate.verify.point1.note',
                {hashAlg: splitMarker}).split(splitMarker)[0] }}
          <b>SHA-2</b>
          {{ $t('wr-notary-certificate.verify.point1.note',
                {hashAlg: splitMarker}).split(splitMarker)[1] }}
          <br>{{ $t('wr-notary-certificate.verify.point1.step1') }}
          <div class="notary-os-switcher">
            <div
              id="js-notary-os-switcher-win"
              class="notary-os-switcher-win "
              :class="{ 'os-switcher-win-active': isWinModeActive }"
              @click="osSwitcherWinSelected"/>
            <div
              id="js-notary-os-switcher-mac"
              class="notary-os-switcher-mac"
              :class="{ 'os-switcher-mac-active': !isWinModeActive }"
              @click="osSwitcherMacSelected"/>
          </div>
          <p/><div
            id="js-notary-hash-win-help"
            v-if="isWinModeActive">
            <br>{{ $t('wr-notary-certificate.verify.point1.step2.win') }}
            <br><br>{{ $t('wr-notary-certificate.verify.point1.step3.win') }}
            <br><br>{{ $t('wr-notary-certificate.verify.point1.step4.win') }}
            <div class="notary-input">
              <div class="notary-input-caption">
                {{ $t('wr-notary-certificate.verify.point1.output-result') }}
              </div>
              <span class="notary-input-status success-message">
                {{ $t('wr-notary-certificate.status-label.verified') }}
              </span>
              <span class="notary-input-status fail-message">
                {{ $t('wr-notary-certificate.status-label.mismatch') }}
              </span>
              <input
                readonly
                type="text"
                :value="getItemHash">
            </div>
          </div>

          <div
            id="js-notary-hash-mac-help"
            v-if="!isWinModeActive">
            <br>{{ $t('wr-notary-certificate.verify.point1.step2.mac') }}
            <br><br>{{ $t('wr-notary-certificate.verify.point1.step3.mac') }}
            <br><br>{{ $t('wr-notary-certificate.verify.point1.step4.mac') }}
            <div class="notary-input">
              <div class="notary-input-caption">
                {{ $t('wr-notary-certificate.verify.point1.output-result') }}
              </div>
              <span class="notary-input-status success-message">
                {{ $t('wr-notary-certificate.status-label.verified') }}
              </span>
              <span class="notary-input-status fail-message">
                {{ $t('wr-notary-certificate.status-label.mismatch') }}
              </span>
              <input
                readonly
                type="text"
                :value="getItemHash">
            </div>
          </div>

          <div
            class="notary-head-point"
            style="margin-top: 80px;">
            <div class="notary-circle-point"><span>2</span></div>
            <div class="notary-point-caption">
              {{ $t('wr-notary-certificate.verify.point2.caption') }}
            </div>
          </div>
          <br>{{ $t('wr-notary-certificate.verify.point2.text1') }}
          <br><br>{{ $t('wr-notary-certificate.verify.point2.text2') }}
          <br><br>{{ $t('wr-notary-certificate.verify.point2.text3') }}
          <br><br>{{ $t('wr-notary-certificate.verify.point2.text4') }}
          <a
            :href="$t('wr.notary-certificate.link.notary-merkling')"
            target="_blank">{{ $t('wr-notary-certificate.verify.point2.merkling-link-name') }}</a>
          <br>
          <div class="notary-sub-point">
            <br>{{ $t('wr-notary-certificate.verify.point2.sub-point1.caption') }}
          </div>
          <br>{{ $t('wr-notary-certificate.verify.point2.sub-point1.pkg-note') }}
          <br><a
            :href="$t('wr.notary-certificate.link.validate-js')"
            target="_blank">
            {{ $t('wr-notary-certificate.verify.point2.sub-point1.pkg-link-name') }}
          </a>
          <div class="notary-input">
            <div class="notary-input-caption">
              {{ $t('wr-notary-certificate.verify.point2.sub-point1.hash-input-name') }}
            </div>
            <span class="notary-input-status success-message">
              {{ $t('wr-notary-certificate.status-label.verified') }}
            </span>
            <span class="notary-input-status fail-message">
              {{ $t('wr-notary-certificate.status-label.mismatch') }}
            </span>
            <input
              v-model="fileHashInput"
              id="js-hash-input"
              type="text">
          </div>
          <div class="notary-input">
            <div class="notary-input-caption">
              {{ $t('wr-notary-certificate.verify.point2.sub-point1.hash-proof-input-name') }}
            </div>
            <span class="notary-input-status success-message">
              {{ $t('wr-notary-certificate.status-label.verified') }}
            </span>
            <span class="notary-input-status fail-message">
              {{ $t('wr-notary-certificate.status-label.mismatch') }}
            </span>
            <input
              v-model="hashProofInput"
              id="js-hash-proof-input"
              type="text">
          </div>
          <br>
          <button
            @click="calculateHashRoot"
            class="b-notary"
            type="submit">
            <b><span>{{ $t('wr-notary-certificate.button.calculate-hash-root') }}</span></b>
          </button>
          <div
            id="js-hash-root-verify-status"
            class="notary-input"
            :class="{ 'verification-fail': isHashStatusInvalid,
                      'verification-success': isHashStatusValid }">
            <div class="notary-input-caption">
              {{ $t('wr-notary-certificate.verify.point2.sub-point1.hash-root-output-name') }}
            </div>

            <span class="notary-input-status success-message">
              {{ $t('wr-notary-certificate.status-label.verified') }}
            </span>
            <span class="notary-input-status fail-message">
              {{ $t('wr-notary-certificate.status-label.mismatch') }}
            </span>

            <input
              v-model="hashRootOutput"
              readonly
              id="js-hash-root-output"
              type="text"
              :placeholder="$t('wr-notary-certificate.placeholder.calculate')"
            >
          </div>
          <br>{{ $t('wr-notary-certificate.verify.point2.sub-point1.text') }}
          <div class="notary-sub-point">
            <br>{{ $t('wr-notary-certificate.verify.point2.sub-point2.caption') }}
          </div>
          <br>{{ $t('wr-notary-certificate.verify.point2.sub-point2.step1') }}
          <br>
          <textarea
            v-model="jsonIdInput"
            id="js-receipt-json"
            class="notary-textarea-input"/>
          <br><br>{{ $t('wr-notary-certificate.verify.point2.sub-point2.step1.note') }}
          <br><br><button
            @click="calculateJsonCrtId"
            class="b-notary"
            type="submit">
            <b><span>{{ $t('wr-notary-certificate.button.calculate-json-hash') }}</span></b>
          </button>
          <div
            id="js-certificate-id-verify-status"
            class="notary-input">
            <div class="notary-input-caption">
              {{ $t('wr-notary-certificate.verify.point2.sub-point2.step1.crt-id-output-name') }}
            </div>
            <span class="notary-input-status success-message">
              {{ $t('wr-notary-certificate.status-label.verified') }}
            </span>
            <span class="notary-input-status fail-message">
              {{ $t('wr-notary-certificate.status-label.mismatch') }}
            </span>
            <input
              v-model="certificateIdInput"
              readonly
              id="js-certificate-id-output"
              type="text"
              :placeholder="$t('wr-notary-certificate.placeholder.calculate')"
            >
          </div>
          <br>{{ $t('wr-notary-certificate.verify.point2.sub-point2.step2') }}
          <div class="notary-input">
            <div class="notary-input-caption">
              {{ $t('wr-notary-certificate.verify.point2.sub-point2.step2.crt-id-input-name') }}
            </div>
            <span class="notary-input-status success-message">
              {{ $t('wr-notary-certificate.status-label.verified') }}
            </span>
            <span class="notary-input-status fail-message">
              {{ $t('wr-notary-certificate.status-label.mismatch') }}
            </span>
            <input
              v-model="certificateIdInput"
              id="js-certificate-id-input"
              type="text">
          </div>
          <div class="notary-input">
            <div class="notary-input-caption">
              {{ $t('wr-notary-certificate.verify.point2.sub-point2.step2.input-name') }}
            </div>
            <span class="notary-input-status success-message">
              {{ $t('wr-notary-certificate.status-label.verified') }}
            </span>
            <span class="notary-input-status fail-message">
              {{ $t('wr-notary-certificate.status-label.mismatch') }}
            </span>
            <input
              v-model="merkleProofInput"
              id="js-merkle-proof-input"
              type="text">
          </div>
          <div class="notary-input">
            <div class="notary-input-caption">
              {{ $t('wr-notary-certificate.verify.point2.sub-point2.step3.input-name') }}
            </div>
            <span class="notary-input-status success-message">
              {{ $t('wr-notary-certificate.status-label.verified') }}
            </span>
            <span class="notary-input-status fail-message">
              {{ $t('wr-notary-certificate.status-label.mismatch') }}
            </span>
            <input
              v-model="merkleRootInput"
              id="js-merkle-root-input"
              type="text">
          </div>
          <br><button
            @click="calculateMerkleRoot"
            class="b-notary"
            type="submit">
            <b><span>{{ $t('wr-notary-certificate.button.calculate-merkle-root') }}</span></b>
          </button>
          <div
            id="js-merkle-verify-status"
            class="notary-input"
            :class="{ 'verification-fail': isMerkleStatusInvalid,
                      'verification-success': isMerkleStatusValid }">
            <div class="notary-input-caption">
              {{ $t('wr-notary-certificate.verify.point2.sub-point2.step2.output-name') }}
            </div>
            <span class="notary-input-status success-message">
              {{ $t('wr-notary-certificate.status-label.verified') }}
            </span>
            <span class="notary-input-status fail-message">
              {{ $t('wr-notary-certificate.status-label.mismatch') }}
            </span>
            <input
              readonly
              id="js-merkle-root-output"
              type="text"
              :placeholder="$t('wr-notary-certificate.placeholder.verify')"
              :value="eTag">
            <div
              id="js-merkle-root-calc-error"
              style="display: none;"
              class="verification-fail-text-error">
              {{ $t('wr-notary-certificate.verify.point2.sub-point2.step2.error-etag') }}
            </div>
          </div>
          <br>
          {{ $t('wr-notary-certificate.verify.point2.sub-point2.step2.text',
                {boldTextMarker: splitMarker}).split(splitMarker)[0] }}
          <b>{{ $t('wr-notary-certificate.verify.point2.sub-point2.step2.text',
                   {boldTextMarker: splitMarker}).split(splitMarker)[1] }}</b>
          {{ $t('wr-notary-certificate.verify.point2.sub-point2.step2.text',
                {boldTextMarker: splitMarker}).split(splitMarker)[2] }}
          <div
            class="notary-head-point"
            style="margin-top: 80px;">
            <div class="notary-circle-point"><span>3</span></div>
            <div class="notary-point-caption">
              {{ $t('wr-notary-certificate.verify.point3.caption') }}
            </div>
          </div>
          <br>{{ $t('wr-notary-certificate.verify.point3.text') }}
          <br><br>{{ $t('wr-notary-certificate.verify.point3.step1.text1') }}
          {{ $t('wr-notary-certificate.verify.point3.step1.text2',
                {ethereumExplorerLink: splitMarker}).split(splitMarker)[0] }}
          <a
            target="_blank"
            :href="$t('wr.notary-certificate.link.etherscan')">
            {{ $t('wr.notary-certificate.link.etherscan') }}
          </a>
          {{ $t('wr-notary-certificate.verify.point3.step1.text2',
                {ethereumExplorerLink: splitMarker}).split(splitMarker)[1] }}
          <div class="notary-input">
            <div class="notary-input-caption">
              {{ $t('wr-notary-certificate.verify.point3.step1.tr-id-input-name') }}
            </div>
            <span class="notary-input-status success-message">
              {{ $t('wr-notary-certificate.status-label.verified') }}
            </span>
            <span class="notary-input-status fail-message">
              {{ $t('wr-notary-certificate.status-label.mismatch') }}
            </span>
            <input
              readonly
              id="js-transaction-id-input"
              type="text"
              :value="getEtheriumTransactionId">
          </div>
          <br>{{ $t('wr-notary-certificate.verify.point3.step2') }}
          <div style="color: #82858f;">
            <br>
            {{ $t('wr-notary-certificate.verify.point3.step2.text',
                  {ethereumExplorerLink: splitMarker}).split(splitMarker)[0] }}
            <a
              target="_blank"
              :href="$t('wr.notary-certificate.link.etherscan')">
              {{ $t('wr.notary-certificate.link.etherscan') }}
            </a>
            {{ $t('wr-notary-certificate.verify.point3.step2.text',
                  {ethereumExplorerLink: splitMarker}).split(splitMarker)[1] }}
          </div>
          <textarea
            readonly
            v-model="etherscanResponseText"
            class="notary-textarea-input"/>
          <br><br>{{ $t('wr-notary-certificate.verify.point3.step2.text2') }}
        </div>


        <div
          class="notary-tech-details-row"
          style="min-height: 224px;">
          <div
            class="notary-tech-details-left"
            style="margin-top: 88px; font-size: 46px;">
            {{ $t('wr-notary-certificate.technical-details.caption') }}
          </div>
          <div
            class="notary-tech-details-right"
            style="margin-top: 88px;">
            {{ $t('wr-notary-certificate.technical-details.details') }}
          </div>
        </div>
        <div class="notary-tech-details-row">
          <div class="notary-tech-details-left">
            <div class="notary-tech-details-left-caption">
              {{ $t('wr-notary-certificate.technical-details.hash') }}
            </div>
            <div>
              {{ $t('wr-notary-certificate.technical-details.nash-note') }}
            </div>
          </div>
          <div
            id="js-th-details-hash"
            class="notary-tech-details-right notary-tech-details-right-color">
            {{ getItemHash }}
          </div>
        </div>
        <div class="notary-tech-details-row">
          <div class="notary-tech-details-left">
            <div class="notary-tech-details-left-caption">
              {{ $t('wr-notary-certificate.technical-details.hash-proof') }}
            </div>
            <div>
              {{ $t('wr-notary-certificate.technical-details.hash-proof-note') }}
            </div>
          </div>
          <div class="notary-tech-details-right notary-tech-details-right-color">
            {{ hashProofText }}
          </div>
        </div>
        <div class="notary-tech-details-row">
          <div class="notary-tech-details-left">
            <div class="notary-tech-details-left-caption">
              {{ $t('wr-notary-certificate.technical-details.hash-root') }}
            </div>
            <div>
              {{ $t('wr-notary-certificate.technical-details.hash-root-note') }}
            </div>
          </div>
          <div class="notary-tech-details-right notary-tech-details-right-color">
            {{ getCrtHashRoot }}
          </div>
        </div>
        <div class="notary-tech-details-row">
          <div class="notary-tech-details-left">
            <div class="notary-tech-details-left-caption">
              {{ $t('wr-notary-certificate.technical-details.blockchain-receipt') }}
            </div>
            <div>
              {{ $t('wr-notary-certificate.technical-details.blockchain-receipt-note') }}
            </div>
          </div>
          <div class="notary-tech-details-right notary-tech-details-right-color">
            <textarea
              v-model="getJsonId"
              readonly
              id="js-th-details-receipt-json"
              class="notary-th-details-textarea"/>
          </div>
        </div>
        <div class="notary-tech-details-row">
          <div class="notary-tech-details-left">
            <div class="notary-tech-details-left-caption">
              {{ $t('wr-notary-certificate.technical-details.merkle-proof') }}
            </div>
            <div>
              {{ $t('wr-notary-certificate.technical-details.merkle-proof-note') }}
            </div>
          </div>
          <div class="notary-tech-details-right notary-tech-details-right-color">
            {{ merklePatriciaProofText }}
          </div>
        </div>
        <div class="notary-tech-details-row">
          <div class="notary-tech-details-left">
            <div class="notary-tech-details-left-caption">
              {{ $t('wr-notary-certificate.technical-details.merkle-root') }}
            </div>
            <div>
              {{ $t('wr-notary-certificate.technical-details.merkle-root-note') }}
            </div>
          </div>
          <div class="notary-tech-details-right notary-tech-details-right-color">
            {{ getMerkleRoot }}
          </div>
        </div>
        <div
          class="notary-tech-details-row"
          style="border-style: none;">
          <div class="notary-tech-details-left">
            <div class="notary-tech-details-left-caption">
              {{ $t('wr-notary-certificate.technical-details.transaction-id') }}
            </div>
            <div>
              {{ $t('wr-notary-certificate.technical-details.transaction-id-note') }}
            </div>
          </div>
          <div class="notary-tech-details-right notary-tech-details-right-color">
            {{ getEtheriumTransactionId }}
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';

import {
  FETCH_NOTARY_CERTIFICATE,
  CALCULATE_MERKLE_TREE_ROOT,
  CALCULATE_CRT_ID,
  UPDATE_VALIDATE_MERKLE_STATUS
} from '../store/action-types';

import {
  VALID_STATUS,
  INVALID_STATUS
} from '../store/verify-status';

import {
  PENDING_STATUS
} from '../store/action-status';

// npm install --save git+https://github.com/acronis/merkle-patricia-tree.git
// const Trie = require('merkle-patricia-tree');

import MerkleTrie from '../store/MerklePatricialTree';

const Trie = new MerkleTrie();

const { mapGetters, mapActions } = createNamespacedHelpers('wr-notary-certificate');

export default {
  name: 'WrNotaryCertificateMain',
  data: function () {
    return {
      fullScreenLoader: '',
      isFullScreenLoaderActive: false,
      isWinModeActive: this.getOSFamily() === 'Win',
      splitMarker: '!@!',
      eTag: '',
      fileHashInput: '',
      hashProofInput: '',
      hashRootOutput: '',
      jsonIdInput: '',
      certificateIdOutput: '',
      certificateIdInput: '',
      merkleProofInput: '',
      merkleRootInput: ''
    };
  },
  computed: {
    ...mapGetters([
      'getFetchNotaryCertificateStatus',
      'getCrtInternalId',
      'getCalculateMerkleRootStatus',
      'getMerkleTreeRoot',
      'getJsonId',
      'getCrtHashRoot',
      'getValidateHashStatus',
      'getCalculateCrtIdStatus',
      'getCalculatedCrtId',
      'getValidateMerkleStatus',
      'getItemHash',
      'getHashList',
      'getMerkleProof',
      'getHashRoot',
      'getMerkleRoot',
      'getEtheriumTransactionId',
      'getDisplayFileName',
      'getCrtDate',
      'getCrtSignee',
      'getSplItemHash'
    ]),
    isHashStatusValid() {
      return this.getValidateHashStatus === VALID_STATUS;
    },
    isHashStatusInvalid() {
      return this.getValidateHashStatus === INVALID_STATUS;
    },
    isMerkleStatusValid() {
      return this.getValidateMerkleStatus === VALID_STATUS;
    },
    isMerkleStatusInvalid() {
      return this.getValidateMerkleStatus === INVALID_STATUS;
    },
    isCalculateMerkleRootInProgress() {
      return this.getCalculateMerkleRootStatus === PENDING_STATUS;
    },
    certUtilUsageText() {
      return `certUtil -hashfile "${this.getDisplayFileName}" SHA256`;
    },
    shasumUsageText() {
      return `shasum -a 256 "${this.getDisplayFileName}"`;
    },
    hashProofText() {
      const hashes = this.getHashList;
      if (hashes === undefined || hashes === null || hashes.length === 0) {
        return '[]';
      }
      return JSON.stringify(hashes);
    },
    merklePatriciaProofText() {
      const hashes = this.getMerkleProof;
      if (hashes === undefined || hashes === null || hashes.length === 0) {
        return '[]';
      }
      return JSON.stringify(hashes);
    },
    etherscanResponseText() {
      return 'Function: register(bytes32 _id)\n\n' +
      `MethodID: 0xe1fa8e84\n[0]:${this.getMerkleRoot}`;
    }
  },
  watch: {
    getFetchNotaryCertificateStatus(status) {
      if (status === PENDING_STATUS) {
        this.showLoading();
      } else {
        this.hideLoading();
      }
    },
    getItemHash(hash) {
      this.fileHashInput = hash;
    },
    hashProofText(hashProof) {
      this.hashProofInput = hashProof;
    },
    getMerkleTreeRoot(merkleTreeRoot) {
      this.hashRootOutput = merkleTreeRoot;
    },
    getJsonId(jsonId) {
      this.jsonIdInput = jsonId;
    },
    getCalculatedCrtId(crtId) {
      this.certificateIdOutput = crtId;
      this.certificateIdInput = crtId;
    },
    merklePatriciaProofText(merkleProofText) {
      this.merkleProofInput = merkleProofText;
    },
    getMerkleRoot(merkleRoot) {
      this.merkleRootInput = merkleRoot;
    }
  },
  methods: {
    ...mapActions({
      fetchNotaryCertificate: FETCH_NOTARY_CERTIFICATE,
      calculateMerkleTreeRoot: CALCULATE_MERKLE_TREE_ROOT,
      calculateCrtId: CALCULATE_CRT_ID,
      updateValidateMerkleStatus: UPDATE_VALIDATE_MERKLE_STATUS
    }),
    osSwitcherWinSelected() {
      this.isWinModeActive = true;
    },
    osSwitcherMacSelected() {
      this.isWinModeActive = false;
    },
    getOSFamily() {
      const app = navigator.appVersion.toLowerCase();
      if (app.indexOf('win') !== -1) return 'Win';
      if (app.indexOf('mac') !== -1) return 'Mac';
      if (app.indexOf('x11') !== -1) return 'Unix';
      if (app.indexOf('linux') !== -1) return 'Linux';
      return 'Unknown';
    },
    showLoading() {
      this.fullScreenLoader = this.$loading({
        background: 'fixed-modal',
        color: 'fixed-white',
        size: '48',
        lock: true
      });
    },
    hideLoading() {
      if (this.fullScreenLoader !== '') {
        this.fullScreenLoader.close();
      }
    },
    calculateHashRoot() {
      this.calculateMerkleTreeRoot({
        hash: this.fileHashInput,
        proof: this.hashProofInput,
        crtHashRoot: this.getCrtHashRoot
      });
    },
    calculateJsonCrtId() {
      this.calculateCrtId({
        jsonid: this.jsonIdInput
      });
    },
    async calculateMerkleRoot() {
      const me = this;
      this.errorEtagText = null;
      this.countedEtag = '';
      Trie.verifyProof(
        this.hexToBin(this.merkleRootInput),
        this.hexToBin(this.certificateIdInput),
        this.hexToBin(JSON.parse(this.merkleProofInput)),
        function (err, value) {
          if (err) {
            console.log(err);
            me.eTag = '';
            me.verifyMerkleRoot();
            return;
          }

          me.eTag = me.uintToStr(value);
          me.verifyMerkleRoot();
        }
      );
    },
    verifyMerkleRoot() {
      if (this.eTag === this.getHashRoot) {
        this.updateValidateMerkleStatus(VALID_STATUS);
      } else {
        this.updateValidateMerkleStatus(INVALID_STATUS);
      }
    },
    uintToStr(uint8) {
      let result = '';
      for (let i = 0; i < uint8.length; i++) {
        result += String.fromCharCode(uint8[i]);
      }
      return result;
    },
    strHex2Bin(str) {
      const array = [];
      for (let i = 0; i < str.length; i += 2) {
        array.push(parseInt(str.slice(i, i + 2), 16));
      }
      return array;
    },
    hexToBin(hex) {
      if (hex instanceof Array) {
        const result = [];
        for (let i = 0; i < hex.length; i++) {
          result.push(this.strHex2Bin(hex[i]));
        }
        return result;
      }
      return this.strHex2Bin(hex);
    },
    makeCertificatePrintable() {
      const elem = document.getElementById('app');
      elem.style.overflow = 'visible';
    },
    init() {
      this.fetchNotaryCertificate(this.$route.params.id);
      this.makeCertificatePrintable();
    }
  },
  async created() {
    await this.init();
  }
};

</script>

<style lang="scss" scoped>

.wr-notary-certificate-main {
  background: #eef2f7;
  color: #2d3138;
  font-size: 13px;
  font-weight: normal;
}

@media print {

  @page {
    size: landscape;
    margin: 0.5cm;
  }

  .wr-notary-certificate-main {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
    color-adjust: exact;
    width: 100%;
    margin: 0;
    padding: 0;
    background: white;
    overflow: visible;
  }

  .not-printable {
    display: none;
  }

  .notary-head-point,
  .notary-textarea-input,
  .notary-input,
  .notary-crt-wrapper,
  .b-notary,
  .notary-os-switcher,
  .notary-tech-details-row {
    page-break-inside: avoid;
  }

}

b {
  font-weight: bold;
}

.notary-crt-wrapper {
  height: 945px;
  background: url('../assets/certificate/certificate-background.png') no-repeat top center;
  background-size: 1488px 945px;
  box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
}

.notary-crt-how-to-block {
  min-height: 800px;
  font-size: 22px;
  line-height: 1.5;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
  padding: 96px 192px;
}

.b-notary {
  font-size: 20px;
  font-weight: bold;
  color: #fff;
  display: inline-block;
  padding: 10px 40px;
  outline: none;
  cursor: pointer;
  text-decoration: none;
  background: #4774b3;
  border-radius: 5px;
  border-style: none;
}

.b-notary:hover {
  background: #5889cc;
  color: #fbfbfb;
}

.notary-tech-details-row {
  min-height: 296px;
  border-bottom: #b3c3dd 2px solid;
  word-wrap: break-word;
  overflow-wrap: break-word;
  line-height: 1.5;
  font-size: 22px;
}

.notary-tech-details-left {
  width: 424px;
  display: inline-block;
  vertical-align: top;
  margin-top: 64px;
  margin-bottom: 64px;
}

.notary-tech-details-right {
  width: 990px;
  display: inline-block;
  vertical-align: top;
  margin-top: 64px;
  margin-bottom: 64px;
  margin-left: 64px;
}

.notary-tech-details-left-caption {
  margin-bottom: 20px;
  font-size: 33px;
}

.notary-tech-details-right-color {
  color: #5873b4;
}

.notary-circle-point {
  width: 64px;
  height: 64px;
  background: #4774b3;
  -moz-border-radius: 50px;
  -webkit-border-radius: 50px;
  border-radius: 50px;
  font-size: 38px;
  font-weight: bold;
  color: #fff;
  text-align: center;
  float: left;
  margin-left: -120px;
}

.notary-circle-point span {
  display: inline-block;
  position: relative;
  margin-top: 3px;
}

.notary-point-caption {
  display: inline-block;
  color: #5873b4;
  font-size: 38px;
  line-height: 64px;
}

.notary-sub-point {
  color: #5873b4;
}

.notary-input {
  margin-top: 32px;
}

.notary-input input {
  width: 100%;
  height: 62px;
  padding-left: 16px;
  padding-right: 16px;
  background: #f1f2f3;
  border-radius: 6px;
  border-style: none;
  line-height: 1.5;
  font-size: 22px;
  margin-top: 8px;
}

.notary-input-caption {
  display: inline-block;
  float: left;
  color: #82858f;
}

.notary-input-status {
  display: none;
  float: right;
}

.verification-success input {
  background: #f1f2f3 url('../assets/certificate/ok.svg') no-repeat 98% 50%;
  background-size: 18px 18px;
}

.verification-success > .success-message {
  color: #86b300;
  display: inline-block;
}

.verification-fail input {
  background: #f1f2f3 url('../assets/certificate/mismatch.svg') no-repeat 98% 50%;
  background-size: 14px 14px;
}

.verification-fail > .fail-message {
  color: #d92c33;
  display: inline-block;
}

.verification-fail-text-error {
  border: 1px solid #d92c33;
  line-height: 64px;
  border-radius: 6px;
  margin-top: 32px;
  padding: 0 32px 0 32px;
  width: 100%;
}

.notary-textarea-input {
  min-width: 1066px;
  min-height: 182px;
  background: #f1f2f3;
  border-style: none;
  font-size: 22px;
  padding: 16px;
}

.notary-th-details-textarea {
  width: 100%;
  border-style: none;
  font-size: 22px;
  min-height: 200px;
  background: inherit;
  color: inherit;
}

.notary-os-switcher {
  border-radius: 5px;
  border: 3px solid #4774b3;
  width: 128px;
  height: 52px;
  padding: 3px;
  margin-top: 32px;
}

.notary-os-switcher-win {
  display: inline-block;
  width: 50%;
  height: 100%;
  background: url('../assets/certificate/windows.svg') no-repeat 50% 50%;
  background-size: 24px 24px;
  float: left;
  cursor: pointer;
}

.notary-os-switcher-mac {
  display: inline-block;
  width: 50%;
  height: 100%;
  background: url('../assets/certificate/apple.svg') no-repeat 50% 50%;
  background-size: 24px 24px;
  float: right;
  cursor: pointer;
}

.os-switcher-win-active {
  background: #4774b3 url('../assets/certificate/windows-white.svg') no-repeat 50% 50%;
}

.os-switcher-mac-active {
  background: #4774b3 url('../assets/certificate/apple-white.svg') no-repeat 50% 50%;
}

.notary-crt-caption {
  display: inline-block;
  float:left;
  position: relative;
  top: 50%; transform:
  translateY(-50%);
  font-size: 46px;
}

.notary-crt-print-button {
  display: inline-block;
  float:right;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

.notary-crt-crt-caption {
  display: inline-block;
  position: absolute;
  top: 120px;
  text-align: center;
  width: 100%;
  font-size: 74px;
  color: #5873b4;
}

.notary-crt-sub-caption {display: inline-block; position: absolute; top: 216px;
  text-align: center;
  width: 100%;
  font-weight: bold;
  font-size: 54px;
  color: #5873b4;
}

.notary-crt-body-text {
  display: inline-block;
  position: absolute;
  top: 352px;
  text-align: center;
  font-size: 28px;
  color: #82858f;
  line-height: 1.4;
  padding-left: 184px;
  padding-right: 184px;
}

.notary-crt-data-view {
  display: inline-block;
  position: absolute;
  top: 670px;
  text-align: center;
  width: 100%;
  word-wrap: break-word;
  overflow-wrap: break-word;
  line-height: 1.4;
}

.notary-crt-name-wrapper {
  width: 384px;
  display: inline-block;
  vertical-align: top;
  padding: 2px;
}

.notary-crt-name-label {
  font-weight: bold;
  font-size: 33px;
  color: #5873b4;
  margin-bottom: 14px;
}

.notary-crt-name {
  font-size: 24px;
  color: #82858f;
}

.notary-crt-date-wrapper {
  width: 384px;
  display: inline-block;
  vertical-align: top;
  padding: 2px;
}

.notary-crt-date-label {
  font-weight: bold;
  font-size: 33px;
  color: #5873b4;
  margin-bottom: 14px;
}

.notary-crt-date {
  font-size: 24px;
  color: #82858f;
}

.notary-crt-signee-wrapper {
  width: 384px;
  display: inline-block;
  vertical-align: top;
  padding: 2px;
}

.notary-crt-signee-label {
  font-weight: bold;
  font-size: 33px;
  color: #5873b4;
  margin-bottom: 14px;
}

.notary-crt-signee {
  font-size: 24px;
  color: #82858f;
}

.notary-crt-verify-wrapper {
  height: 224px;
  text-align: center;
}

.notary-crt-verify-caption {
  display: inline-block;
  width: 100%;
  margin-top: 72px;
  font-size: 46px;
}

.notary-crt-verify-note {
  display: inline-block;
  width: 100%;
  margin-top: 24px;
  font-size: 22px;
  line-height: 1.4;
}

</style>
